import { Component, Input } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { Rodeo } from '../../../../../model/rodeo';
import { DatePipe } from '@angular/common';
import { ReportsService } from '../../../../../services/reports.service';
import { PrintService } from '../../../../../services/print-service';
import { Progression } from '../../../../../model/progression';
import { RodeoEventSchedule } from 'model/rodeoEventSchedule';
import { RodeoEvent } from 'model/rodeoEvent';

@Component({
    selector: 'page-progression-report',
    templateUrl: 'progression-report.html'

})
export class ProgressionReport {
    @Input('rodeo') rodeo: Rodeo;
    @Input('rodeo') progression: Progression;
    
    progressionDestinationDescription: string;
    destinationSchedule: RodeoEventSchedule;
    destinationRodeoEvent: RodeoEvent;
    sourceMap: any[] = [];
    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    constructor(private printService: PrintService, private nav: NavController, navParams: NavParams, private datePipe: DatePipe, private reportService: ReportsService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        if (!this.progression)
            this.progression = navParams.get('progression');

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => { 
            rodeoEvent.schedules.forEach((schedule) => {
                if (schedule.id == this.progression.toRodeoEventScheduleId) {
                    this.destinationRodeoEvent = rodeoEvent;
                    this.destinationSchedule = schedule;
                    return;
                }
            })
        })

        this.progressionDestinationDescription = this.destinationRodeoEvent.displayName + " - " + this.destinationSchedule.name + " Round " + this.progression.toRound;

        this.sourceMap = [];

        this.progression.progressionSources.forEach((source) => {
            this.sourceMap[source.id] = this.rodeo.payoutConfigs.filter(x => x.id == source.payoutConfigId)[0].name;
        });

        console.log("destinationSchedule: ", this.destinationSchedule);

        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        this.documentTitle = this.rodeo.name + " - " + this.progressionDestinationDescription;
        this.dataLoaded = true;
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    matchSchedules(a, b) {
     return a.name.toLowerCase() == b.name.toLowerCase();
    }

    matchRounds(a, b) {
        return a == b;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    async print() {
        this.printing = true;
        await this.printService.print(this.documentTitle);
        this.printing = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/progressions/progression-report.ts